import axios from './axios';

export const getToolboxTalkRuns = ({ params } = {}) => axios.get(`toolbox-talks/runs`, { params });
export const getToolboxTalkRun = ({ id, params } = {}) => axios.get(`toolbox-talks/runs/${id}`, { params });
export const runToolboxTalkNow = () => axios.post(`toolbox-talks/run-now`);

// Document management
export const getToolboxTalkDocuments = ({ params } = {}) => axios.get(`toolbox-talks`, { params });
export const getToolboxTalkDocument = ({ id, params } = {}) => axios.get(`toolbox-talks/${id}`, { params });
export const createToolboxTalkDocument = (formData) => axios.post(`toolbox-talks`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const updateToolboxTalkDocument = ({ id, formData }) => axios.put(`toolbox-talks/${id}`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deleteToolboxTalkDocument = ({ id }) => axios.delete(`toolbox-talks/${id}`);
export const toggleToolboxTalkDocumentActive = ({ id }) => axios.patch(`toolbox-talks/${id}/toggle-active`);
export const getToolboxTalkStatistics = () => axios.get(`toolbox-talks/statistics`);

// Admin PDF download for signed TBT records
export const downloadSignedTbtPdf = ({ signedId }) => axios.get(`toolbox-talks/signed/${signedId}/download`);

// Enhanced "Run Now" functionality
export const getProjectsForTbt = () => axios.get('/toolbox-talks/projects', {
  params: { 'filter[status_key]': 2 }
});
export const getSubcontractorsForTbt = (projectId = null) => {
    const params = projectId ? { project_id: projectId } : {};
    return axios.get('/toolbox-talks/subcontractors', { params });
};
export const getScheduledSubcontractorsForTbt = () => axios.get('/toolbox-talks/scheduled-subcontractors');
export const runSelectiveTbt = (distributionOptions) => axios.post('/toolbox-talks/run-selective', distributionOptions);

// Project TBT Reports
export const getProjectTbtRuns = (projectId) => axios.get(`/projects/${projectId}/tbt-runs`);
export const downloadProjectTbtPdf = (runId, projectId) => axios.get(`/tbt-runs/${runId}/project-pdf`, {
  params: { project_id: projectId },
  responseType: 'blob'
});

// Placeholder editor
export const getTbtDocumentPdfInfo = (id) => axios.get(`toolbox-talks/${id}/pdf-info`);
export const getTbtDocumentPdfUrl = (id) => axios.get(`toolbox-talks/${id}/pdf-url`);
export const getTbtDocumentPdfContent = (id) => axios.get(`toolbox-talks/${id}/pdf-content`, { responseType: 'arraybuffer' });
export const saveTbtPlaceholderConfig = (id, config) => axios.put(`toolbox-talks/${id}/placeholder-config`, { placeholder_config: config });
export const previewTbtPlaceholders = (id) => axios.get(`toolbox-talks/${id}/preview-placeholders`, { responseType: 'blob' });

// Update TBT run status for selected subcontractors
export const updateTbtRunStatus = (runId, subcontractorIds, status) => axios.put(`toolbox-talks/runs/${runId}/update-status`, {
  subcontractor_ids: subcontractorIds,
  status: status
});

// Send manual reminder for TBT run to selected subcontractors
export const sendTbtReminder = (runId, subcontractorIds) => axios.post(`toolbox-talks/runs/${runId}/send-reminder`, {
  subcontractor_ids: subcontractorIds
});

export const downloadSelectedSubcontractorsPdf = (runId, subcontractorIds) => axios.get(`/tbt-runs/${runId}/selected-subcontractors-pdf`, {
  params: { 'subcontractor_ids[]': subcontractorIds },
  responseType: 'blob',
  paramsSerializer: params => {
    return Object.entries(params)
      .flatMap(([key, values]) =>
        Array.isArray(values)
          ? values.map(value => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          : `${encodeURIComponent(key)}=${encodeURIComponent(values)}`
      )
      .join('&');
  }
});
